import ActivitiLogCell from './component'

export default ActivitiLogCell
